import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Bundle from './bundle';

const Wrapper = styled.div`
    flex-direction: column;
    width: 100%;
`;
const SubHeader = styled.div`
    font-size: 24px;
    line-height: 32px;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    margin-bottom: 25px;
`;
const ChannelDescription = styled.div`
    color: ${COLORS.darkGrey};
    font-size: 16px; 
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    align-content: center;
    margin-bottom: 30px;
`;
const ChannelLogo = styled.img`
    width: 63px;
    height: 63px;
    margin-right: 20px;
`;
const Text = styled.div`
    max-width: 85%;
    align-content: center;
    @media (max-width: 500px) {
        max-width: 100%;
        margin-top: 15px;
    }
`;

const ChannelSearchResult = ({ channel }) => {
    const { title, logo, description, channelPackages = [], salePackages = [] } = channel;
    return (
        <Wrapper id='channel_search_result'>
            <SubHeader>Результаты поиска «{title}»</SubHeader>
            <ChannelDescription>
                <ChannelLogo src={logo} />
                <Text>{description}</Text>
            </ChannelDescription>
            <SubHeader>Куда входит канал:</SubHeader>
            {channelPackages.map((p, key) => <Bundle key={key} bundle={p} />)}
            {salePackages.map((p, key) => <Bundle key={key} bundle={p} isTariff={true} />)}
        </Wrapper>
    );
};
export default ChannelSearchResult;
